import { LOGO } from "@/data/content";

// Brand lockup matching the live aquafionix.com header:
// original circular phoenix logo + "AquaFionix" (Aqua white, Fionix cyan gradient), no tagline.
export default function Brand({ onClick, testId, badgeSize = "h-10 w-10 sm:h-12 sm:w-12", nameClass = "text-lg sm:text-2xl", as = "button" }) {
  const Wrapper = as;
  return (
    <Wrapper onClick={onClick} data-testid={testId} className="flex items-center gap-2.5 group text-left">
      <span className={`relative ${badgeSize} rounded-full overflow-hidden bg-white ring-1 ring-white/25 shadow-[0_6px_20px_rgba(0,240,255,0.22)] shrink-0 transition-transform group-hover:-translate-y-0.5`}>
        <img src={LOGO} alt="AquaFionix logo" className="h-full w-full object-cover scale-[1.02]" />
      </span>
      <span className={`font-display font-extrabold tracking-tight ${nameClass}`}>
        <span className="text-white">Aqua</span><span className="text-gradient-cyan">Fionix</span>
      </span>
    </Wrapper>
  );
}
